import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AuthWrapper } from "~/components/auth/AuthWrapper";

export const Route = createFileRoute("/auth")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AuthWrapper>
      <Outlet />
    </AuthWrapper>
  );
}
